import { Link } from 'react-router-dom';

const services = [
  {
    id: 1,
    number: '01',
    title: 'Parsiyel Taşımacılık',
    description: 'Avrupa\'ya gönderilecek küçük hacimli yüklerinizi, diğer müşterilerimizle aynı araçta uygun fiyata 27 ülkeye taşıyoruz.',
    icon: 'ri-box-3-line',
    href: '/hizmetlerimiz/parsiyel',
    image: '/media/search-image-408e43457c.jpg',
  },
  {
    id: 2,
    number: '02',
    title: 'Komple Araç',
    description: 'Büyük hacimli yükleriniz için tüm araç tahsis ediyoruz. Türkiye\'den Avrupa\'nın her ülkesine en hızlı ve güvenli taşıma.',
    icon: 'ri-truck-line',
    href: '/hizmetlerimiz/komple-arac',
    image: '/media/search-image-164100212e.jpg',
  },
  {
    id: 3,
    number: '03',
    title: 'Ev & Ofis Taşıma',
    description: 'Türkiye\'nin 81 ilinden Avrupa\'nın 27 ülkesine ev eşyası ve ofis taşımacılığında anahtar teslim, hasarsız teslimat.',
    icon: 'ri-home-4-line',
    href: '/hizmetlerimiz/ev-ofis-tasima',
    image: '/media/search-image-13d4b71848.jpg',
  },
  {
    id: 4,
    number: '04',
    title: 'Hızlı Kargo',
    description: 'Acil gönderileriniz için ekspres taşımacılık seçeneğimizle Avrupa\'nın herhangi bir ülkesine kapıdan kapıya 3-5 iş günü teslimat.',
    icon: 'ri-flashlight-line',
    href: '/hizmetlerimiz/hizli-kargo',
    image: '/media/search-image-efc10dec0c.jpg',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="text-brand-orange font-semibold text-sm uppercase tracking-widest mb-3">Hizmetlerimiz</p>
            <h2 className="text-brand-navy font-heading font-bold text-3xl md:text-4xl">
              Türkiye'den Avrupa'ya
              <br />
              Kapsamlı Lojistik Çözümler
            </h2>
          </div>
          <p className="text-gray-400 text-sm md:text-base max-w-sm">
            Türkiye'nin 81 ilinden Avrupa'nın 27 ülkesine her boyutta yük için profesyonel taşımacılık hizmetleri.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <Link
              key={service.id}
              to={service.href}
              className="group rounded-2xl overflow-hidden border border-gray-100 hover:border-brand-orange/20 transition-all duration-300 hover:-translate-y-1 cursor-pointer block"
            >
              {/* Image */}
              <div className="relative overflow-hidden h-44">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/60 to-transparent"></div>
                <div className="absolute top-3 left-3 bg-white/10 backdrop-blur-sm border border-white/20 text-white px-2 py-0.5 rounded-full text-xs font-semibold">
                  {service.number}
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/10 text-brand-orange rounded-xl mb-3">
                  <i className={`${service.icon} text-xl`}></i>
                </div>
                <h3 className="text-brand-navy font-heading font-bold text-base mb-2">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{service.description}</p>

                <div className="mt-4 flex items-center gap-1 text-brand-orange text-sm font-semibold group-hover:gap-2 transition-all">
                  <span>Detaylı Bilgi</span>
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <a
            href="https://wa.me/905322376576?text=Merhaba,%20fiyat%20teklifi%20almak%20istiyorum."
            target="_blank"
            rel="nofollow noreferrer"
            className="inline-flex items-center gap-3 bg-brand-navy hover:bg-gray-800 text-white px-8 py-4 rounded-md font-semibold transition-all duration-300 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap text-sm"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-whatsapp-line text-lg text-whatsapp"></i>
            </span>
            WhatsApp ile Fiyat Teklifi Al
          </a>
        </div>
      </div>
    </section>
  );
}
